import Vue from 'vue'
import Vuex from 'vuex'

import alerts from './modules/alerts'
import auth from './modules/auth'
import billing from './modules/billing'
import dashboards from './modules/dashboards'
import filters from './modules/filters'
import leads from './modules/leads'
import payment_methods from './modules/payment_methods'
import pro_users from './modules/pro_users'
import services from './modules/services'
import wizard from './modules/wizard'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    alerts,
    auth,
    billing,
    dashboards,
    filters,
    leads,
    payment_methods,
    pro_users,
    services,
    wizard,
  },

  strict: debug,
})
